import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import {
    FAILURE_PARTNER_NO_PAYOUT_RATIONALES,
    REQUEST_PARTNER_NO_PAYOUT_RATIONALES,
    SUCCESS_PARTNER_NO_PAYOUT_RATIONALES,
} from './actions';

export function partnerNoPayoutRationaleReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_PARTNER_NO_PAYOUT_RATIONALES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_PARTNER_NO_PAYOUT_RATIONALES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_PARTNER_NO_PAYOUT_RATIONALES:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
